import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import '@purple/semantic-ui-family-connection-theme/components/icon.css';

export default Icon;
